import { FunctionComponent } from 'react';

const BankAccountFormStyles: FunctionComponent = () => {
  return(
    <style>
      {`
      /* Global
      =================== */
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        font-size: 16px;
        font-family: 'Lato', sans-serif;
      }
      
      
      /* ACH Form
      =================== */
      .bank-account-form-field:not(:last-child) {
        margin-bottom: 20px;
        /* to do: default this to what we need in our checkout */
      }
      
      
      /* ACH Form
      =================== */
      .bank-account-form-input,
      .bank-account-form-input-white {
        border: none;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 100%;
        border: none;
        color: rgba(0, 0, 0, 0.87);
        max-width: 100%;
        height: 55px;
        padding: 0 12px;
      }
      
      .bank-account-form-input {
        background-color: #F4F4F6;
      }
      
      .bank-account-form-input-white {
        background-color: #FFFFFF;
      }
      
      .bank-account-form-input:focus::placeholder {
        color: black;
      }
      
      .bank-account-form-input:focus,
      .bank-account-form-input-white:focus {
        outline: none;
      }
      `}
    </style>
  );
};

export default BankAccountFormStyles;
